import useScreenSize from "../hooks/useScreenSize";

export default function Intro() {
	const screenSizes = useScreenSize();

	let imgUrl = "https://s3.kftus.com/kft-cms/website_title_b5c6128cd7.webp";

	if (screenSizes.isLarge) {
		imgUrl = "https://s3.kftus.com/kft-cms/website_title_2ea068151b.webp";
	}

	return (
		<div id="siteIntro">
			<div className="introDescription">
				CALLING ALL BOBA CIVILIANS! AWAKEN YOUR BOBA MASTER TO CELEBRATE
				THE UPCOMING RELEASE OF METAPHOR: REFANTAZIO AT YOUR LOCAL KUNG
				FU TEA! STARTING TODAY YOU CAN PICK UP ONE OF OUR
				METAPHOR-INSPIRED DRINKS AND GRAB A LIMITED-EDITION STICKER WITH
				YOUR PURCHASE*! WHO WILL YOU BECOME IN THE UNITED KINGDOM OF
				EUCHRONIA?
				<br />
				*While Supplies Last
			</div>
			<img
				src={imgUrl}
				style={{
					width: "100%",
					display: "block"
				}}
			></img>
		</div>
	);
}
